/* ============================================================
   100Days.co — Custom Homepage JS
   Compatible with: Shopify Refine 3.1.0
   ============================================================ */
(function () {
  'use strict';

  /* ── Scroll reveal ── */
  function initScrollReveal() {
    if (typeof IntersectionObserver === 'undefined') {
      document.querySelectorAll('.c-fade-up').forEach(function (el) {
        el.classList.add('c-visible');
      });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('c-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.c-fade-up').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ── Timeline (desktop) ── */
  function initTimeline() {
    var nodes = document.querySelectorAll('.c-tl-node');
    var panels = document.querySelectorAll('.c-tl-panel');
    if (!nodes.length) return;

    nodes.forEach(function (node, i) {
      node.addEventListener('click', function () {
        nodes.forEach(function (n) { n.classList.remove('is-active'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        node.classList.add('is-active');
        if (panels[i]) panels[i].classList.add('is-active');
      });
    });
  }

  /* ── Timeline (mobile accordion) ── */
  function initTimelineMobile() {
    var headers = document.querySelectorAll('.c-tl-panel-header');
    headers.forEach(function (header) {
      header.addEventListener('click', function () {
        var panel = header.parentElement;
        var isOpen = panel.classList.contains('mob-open');
        document.querySelectorAll('.c-tl-panel').forEach(function (p) {
          p.classList.remove('mob-open');
        });
        if (!isOpen) panel.classList.add('mob-open');
      });
    });
    // Open first panel on mobile by default
    var first = document.querySelector('.c-tl-panel');
    if (first) first.classList.add('mob-open');
  }

  /* ── Service cards ── */
  function initServiceCards() {
    var cards = document.querySelectorAll('.c-service');
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        cards.forEach(function (c) { c.classList.remove('is-active'); });
        card.classList.add('is-active');
      });
    });
  }

  /* ── FAQ accordion ── */
  function initFaq() {
    var questions = document.querySelectorAll('.c-faq-q');
    questions.forEach(function (q) {
      q.addEventListener('click', function () {
        var answer = q.nextElementSibling;
        var isOpen = q.classList.contains('is-open');

        // Close all
        document.querySelectorAll('.c-faq-q').forEach(function (item) {
          item.classList.remove('is-open');
          var a = item.nextElementSibling;
          if (a) a.classList.remove('is-open');
        });

        // Open clicked if was closed
        if (!isOpen) {
          q.classList.add('is-open');
          if (answer) answer.classList.add('is-open');
        }
      });
    });
  }

  /* ── Count-up animation for stats ── */
  function initCountUp() {
    var stats = document.querySelectorAll('[data-countup]');
    if (!stats.length || typeof IntersectionObserver === 'undefined') return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-countup'));
        var suffix = el.getAttribute('data-suffix') || '';
        var duration = 1200;
        var start = 0;
        var startTime = null;

        function step(timestamp) {
          if (!startTime) startTime = timestamp;
          var progress = Math.min((timestamp - startTime) / duration, 1);
          var ease = 1 - Math.pow(1 - progress, 3);
          var current = Math.round(ease * target);
          el.textContent = current + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        observer.unobserve(el);
      });
    }, { threshold: 0.5 });

    stats.forEach(function (el) { observer.observe(el); });
  }

  /* ── Init all on DOM ready ── */
  function init() {
    initScrollReveal();
    initTimeline();
    initTimelineMobile();
    initServiceCards();
    initFaq();
    initCountUp();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section load (theme editor live preview)
  document.addEventListener('shopify:section:load', function () {
    init();
  });

})();


/* ─── 100Days Header: Logo swap & dark-theme enforcement ─── */
(function () {
  var LOGO_URL = 'https://cdn.shopify.com/s/files/1/0665/0825/9528/files/100days-wordmark.png?v=1779535589';
  var LOGO_ALT = '100Days — Digital Commerce Experts';

  function swapLogo() {
    // Swap any img inside the Refine logo container
    var logoContainers = document.querySelectorAll(
      '.section-header-logo, .section-header-root-link img, .floating-logo img'
    );
    logoContainers.forEach(function (el) {
      if (el.tagName === 'IMG') {
        if (el.src !== LOGO_URL) {
          el.src = LOGO_URL;
          el.alt = LOGO_ALT;
          el.style.maxHeight = '38px';
          el.style.width = 'auto';
        }
      } else {
        var imgs = el.querySelectorAll('img');
        imgs.forEach(function (img) {
          if (img.src !== LOGO_URL) {
            img.src = LOGO_URL;
            img.alt = LOGO_ALT;
            img.style.maxHeight = '38px';
            img.style.width = 'auto';
          }
        });
        // Also show if hidden
        el.style.display = '';
      }
    });

    // Hide shop-name text if a logo image exists
    var hasLogoImg = document.querySelector('.section-header-logo img');
    var shopName = document.querySelector('.section-header-shop-name');
    if (hasLogoImg && shopName) shopName.style.display = 'none';
  }

  function enforceHeaderDark() {
    // Ensure header bg is dark (catches JS-injected inline styles from Refine)
    var hdr = document.querySelector('.section-header-container');
    if (hdr) {
      hdr.style.setProperty('background-color', '#0a0a0a', 'important');
    }
    // Ensure announce bar is dark
    var ann = document.querySelector('.section-announcement');
    if (ann) {
      ann.style.setProperty('background-color', '#0d1f1e', 'important');
      // Force all links inside to be visible
      ann.querySelectorAll('a, span, p').forEach(function(el) {
        el.style.setProperty('color', '#00d4c8', 'important');
      });
    }
  }

  function init() {
    swapLogo();
    enforceHeaderDark();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run after a short delay in case Refine hydrates the header asynchronously
  setTimeout(init, 500);
  setTimeout(init, 1500);

  // Also re-run on section reload
  document.addEventListener('shopify:section:load', init);
})();
